import { render, staticRenderFns } from "./select-typeahead.vue?vue&type=template&id=3b09749c"
import script from "./select-typeahead.vue?vue&type=script&lang=js"
export * from "./select-typeahead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports